@if (showFilterInput) {
    <sew-table-header-filter
        [label]="name"
        [sortOrder]="sortOrderObs | async"
        [sortDefault]="'SORT_ORDER.DEFAULT' | translate: { label: name }"
        [sortDescending]="'SORT_ORDER.DESCENDING' | translate: { label: name }"
        [sortAscending]="'SORT_ORDER.ASCENDING' | translate: { label: name }"
        [hideSortIconOnClosedState]="hideSortIconOnClosedState"
        [ellipsis]="ellipsis"
        (sort)="updateSorting($any($event).detail)"
    >
        <input type="text" [ngModel]="filterValue | async" (ngModelChange)="updateFilter($event)" />
    </sew-table-header-filter>
} @else {
    <sew-table-header-sort
        [label]="name"
        [sortOrder]="sortOrderObs | async"
        [sortDefault]="'SORT_ORDER.DEFAULT' | translate: { label: name }"
        [sortDescending]="'SORT_ORDER.DESCENDING' | translate: { label: name }"
        [sortAscending]="'SORT_ORDER.ASCENDING' | translate: { label: name }"
        [ellipsis]="ellipsis"
        (sort)="updateSorting($any($event).detail)"
    ></sew-table-header-sort>
}
